<div class="tableColumnText {{ cssClass }}" [matTooltip]="tooltip" [matTooltipClass]="tooltipClass">{{ displayedText }}</div>
